module.exports = __webpack_public_path__ + "img/plus-button.f4e01ca0.svg";